import { DateTimePicker } from 'blaze-ui/DateTimePicker/DateTimePicker'
import { getLocalTimeZone, today } from '@internationalized/date'
import dayjs from 'dayjs'
import { Button } from 'blaze-ui/Button'
import { Calendar2, ChevronDown2 } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'
import { useField } from 'formik'
import { StartDatePickerProps } from 'screens/Campaigns/components/AddCampaignModal/CreateCampaign/Types'

export const StartDatePicker = ({ name, ...rest }: StartDatePickerProps) => {
  const [startDateField, , { setValue: setStartDate }] = useField<string>(name)

  return (
    <DateTimePicker
      disableDatesBefore={today(getLocalTimeZone()).add({ days: 1 }).toString()}
      dateTime={dayjs(startDateField.value)}
      setDateTime={(date) => {
        if (!date) return
        setStartDate(date.format('YYYY-MM-DD'))
      }}
      showTimeControls={false}
    >
      <Button
        {...rest}
        frontIcon={Calendar2}
        size="lg"
        variant="secondary"
        endIcon={ChevronDown2}
        aria-label="Start date"
      >
        <Text variant="primary" color="var(--dark-80)">
          {dayjs(startDateField.value).format('ddd MMM D')}
        </Text>
      </Button>
    </DateTimePicker>
  )
}
